import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgentQuestionnaireComponent } from './agent-questionnaire/agent-questionnaire.component';

const routes: Routes = [{ path: '', component: AgentQuestionnaireComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentQuestionnaireRoutingModule {}
